import { IPlatformCerts } from "./platform-certs";
import { IReceiver } from './receiver';

/**
 * Base Interface representing a Platform
 */
export interface IPlatform {
  id: number;
  name: string;
  createdAt: string;
  numReceivers: number;
  platformCerts: IPlatformCerts[];
  receivers: IReceiver[];
}


export let emptyPlatform: IPlatform = {
  id: -1,
  name: '',
  createdAt: '',
  numReceivers: 0,
  platformCerts: [],
  receivers: [],
};



// WEBPACK FOOTER //
// ./src/app/model/platform.ts